import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import { tablePaginationClasses as classes } from "@mui/material";
import FirstPageRoundedIcon from "@mui/icons-material/FirstPageRounded";
import LastPageRoundedIcon from "@mui/icons-material/LastPageRounded";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import { TablePagination, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLoaderContext, useToastContext } from "../../../../Context/ToastContext";
import Dropdown from "../../Dropdown/Dropdown";
import { useUserContext } from "../../../../Context/UserContext";
import { apiGet, apiPost, apiPut } from "../../../../utils/ApiManager";

const fetchUnitListDropdown = process.env.REACT_APP_FETCH_UNIT_LIST
const getHandleRegister = process.env.REACT_APP_HANDLE_REGISTER_RECIPE_INGREDIENT
const fetchDataAllIngredients = process.env.REACT_APP_FETCH_DATA_RECIPE_ALL_INGREDIENTS


const IngredientList = () => {
  const { showToast } = useToastContext();
  const { getToken } = useUserContext();
  const { setLoading} = useLoaderContext();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalCount, setTotalCount] = useState(100);
  const [data, setData] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [unitList, setUnitList] = useState([]);
  const [editingData, setEditingData] = useState({
    ingredientCode: "",
    ingredientName: "",
    unit: ""
  })

  const navigateTo = useNavigate();

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(1);
  };

  const fetchUnitList = async () => {
    try {
      const response = await apiGet(fetchUnitListDropdown);
      if (response.success) {
        setUnitList(response?.data || []);
      }
    } catch (error) {
      showToast(error?.response?.message || "Error fetching unit list !", "error")
    }
  }

  const handleRegister = async () => {
    try {
      setLoading(true);
      const response = await apiPost(getHandleRegister, editingData);
      if (response.success) {
        showToast(response.message || 'Ingredient registered successfully', 'success');
        setOpenModal(false);
        fetchData();
      }
    } catch (error) {
      showToast(error?.response?.message || "Error registering ingredient!", "error");
    }finally{
      setLoading(false);
    }
  };

  useEffect(() => {
    if (openModal) {
      fetchUnitList();
    }
  }, [openModal])

  const handleUpdate = async () => {
    try {
      setLoading(true);
      const response = await apiPut(getHandleRegister, editingData);
      if (response.success) {
        showToast(response.message || 'Ingredient registered successfully', 'success');
        setOpenModal(false);
        fetchData();
      }
    } catch (error) {
      showToast(error?.response?.message || "Error updatibg ingredient!", "error");
    }finally{
      setLoading(false);
    }
  }
  const handleCloseModel = () => {
    setOpenModal(false);
    setIsUpdating(false);

  }

  const handleAddNewClick = () => {
    setEditingData({
      ingredientName: "",
      unit: ""
    })
    setOpenModal(true);
  }

  const handleUpdateClick = (ingredientData) => {
    setEditingData({ ...ingredientData });
    setOpenModal(true);
    setIsUpdating(true);
  }


  const fetchData = async () => {
    try {
      let params = {
        pageSize: rowsPerPage,
        pageNo: page
      }
      const queryString = new URLSearchParams(params).toString();
      const response = await apiGet(`${fetchDataAllIngredients}?${queryString}`)
      if (response.success) {
        setData(response?.data || []);
        setTotalCount(response.totalCount || 0);
      } else {
        showToast(response?.message || "Error fetching ingredient list!", "error");
      }
    } catch (error) {
      showToast(
        error?.response?.message || error?.message || "Something went wrong !",
        "error"
      );
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditingData({ ...editingData, [name]: value });
  }
  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage]);

  return (
    <Root sx={{ width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "20px" }}>
      <Button onClick={handleAddNewClick} variant="contained" >
        Register New Ingredient
      </Button>
      <Typography variant="h4" gutterBottom sx={{ textAlign: "center", marginBottom: "20px" }}>
        Ingredient Data
      </Typography>
      <TableContainer component={Paper} sx={{ borderRadius: "10px", boxShadow: 3 }}>
        <Table aria-label="ingredient table">
          <TableHead>
            <TableRow>
              <TableCell sx={tableHeaderStyle}>Sr. No</TableCell>
              {/* <TableCell sx={tableHeaderStyle}>Ingredient ID</TableCell> */}
              <TableCell sx={tableHeaderStyle}>Ingredient Name</TableCell>
              <TableCell sx={tableHeaderStyle}>Ingredient Code</TableCell>
              <TableCell sx={tableHeaderStyle}>Unit</TableCell>
              {/* <TableCell sx={tableHeaderStyle}>View</TableCell> */}
              <TableCell sx={tableHeaderStyle}>Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data &&
              data.map((ingredient, index) => (
                <TableRow key={index}>
                  <TableCell sx={tableCellStyle}>{rowsPerPage * (page - 1) + index + 1}</TableCell>
                  {/* <TableCell sx={tableCellStyle}>{ingredient?.ingredientId}</TableCell> */}
                  <TableCell sx={tableCellStyle}>{ingredient?.ingredientName}</TableCell>
                  <TableCell sx={tableCellStyle}>{ingredient?.ingredientCode}</TableCell>
                  <TableCell sx={tableCellStyle}>{ingredient?.unit}</TableCell>
                  {/* <TableCell sx={tableCellStyle}>
                    <IconButton
                      onClick={() => handleView(ingredient?.ingredientId)}
                      color="primary"
                    >
                      <VisibilityIcon />
                    </IconButton>
                  </TableCell> */}
                  <TableCell sx={tableCellStyle}>
                    <IconButton onClick={() => handleUpdateClick(ingredient)} color="primary">
                      <ModeEditOutlineIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <CustomTablePagination
        rowsPerPageOptions={[5, 10, 15]}
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        slotProps={{
          select: {
            "aria-label": "Rows per page",
          },
          actions: {
            showFirstButton: true,
            showLastButton: true,
            slots: {
              firstPageIcon: FirstPageRoundedIcon,
              lastPageIcon: LastPageRoundedIcon,
              nextPageIcon: ChevronRightRoundedIcon,
              backPageIcon: ChevronLeftRoundedIcon,
            },
          },
        }}
      />
      <Dialog open={openModal}>
        <DialogTitle>{isUpdating ? "Edit Ingredient" : "Add New Ingredient"}</DialogTitle>
        <DialogContent>
          {isUpdating && (
            <TextField
              label="Ingredient Code"
              variant="outlined"
              fullWidth
              margin="normal"
              placeholder="eg. Termeric (Haldi)"
              name="ingredientName"
              disabled
              value={editingData?.ingredientCode}
            />
          )}
          <TextField
            label="Ingredient Name"
            variant="outlined"
            fullWidth
            margin="normal"
            placeholder="eg. Termeric (Haldi)"
            name="ingredientName"
            value={editingData?.ingredientName}
            onChange={handleChange}
          />
          <Dropdown label="Unit" name="unit" value={editingData?.unit} options={unitList} showSelect={false} onChange={handleChange} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModel} color="secondary">
            Cancel
          </Button>
          <Button color="primary" onClick={() => {
            if (isUpdating) handleUpdate();
            else handleRegister();
          }}>{isUpdating ? "Update Ingredient" : "Add Ingredient"}</Button>
        </DialogActions>
      </Dialog>
    </Root>
  );
};

const Root = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: "#f4f6f8",
  padding: "20px",
  borderRadius: "15px",
});

const tableHeaderStyle = {
  fontWeight: "600",
  backgroundColor: "#f1f1f1",
  fontSize: "14px",
};

const tableCellStyle = {
  padding: "12px 16px",
  fontSize: "14px",
  borderBottom: "1px solid #ddd",
};

const CustomTablePagination = styled(TablePagination)(
  ({ theme }) => `
  & .${classes.spacer} {
    display: none;
  }

  & .${classes.toolbar} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    background-color: ${theme.palette.mode === "dark" ? "#2c2f37" : "#fff"};

    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
    }
  }

  & .${classes.selectLabel} {
    margin: 0;
  }

  & .${classes.select} {
    font-family: 'Roboto', sans-serif;
    padding: 4px;
    border: 1px solid ${theme.palette.mode === "dark" ? "#444" : "#ddd"};
    border-radius: 6px;
    background-color: transparent;
    color: ${theme.palette.mode === "dark" ? "#e0e0e0" : "#333"};
    transition: all 100ms ease;

    &:hover {
      background-color: ${theme.palette.mode === "dark" ? "#444" : "#f9f9f9"};
      border-color: ${theme.palette.mode === "dark" ? "#666" : "#ccc"};
    }

    &:focus {
      outline: 3px solid ${theme.palette.mode === "dark" ? "#4CAF50" : "#2196F3"};
    }
  }

  & .${classes.actions} {
    display: flex;
    gap: 10px;
  }

  & .${classes.actions} > button {
    padding: 8px;
    border-radius: 50%;
    background-color: transparent;
    border: 1px solid ${theme.palette.mode === "dark" ? "#444" : "#ddd"};
    color: ${theme.palette.mode === "dark" ? "#e0e0e0" : "#333"};
    transition: background-color 0.2s ease, border-color 0.2s ease;

    > svg {
      font-size: 22px;
    }

    &:hover {
      background-color: ${theme.palette.mode === "dark" ? "#444" : "#f1f1f1"};
      border-color: ${theme.palette.mode === "dark" ? "#666" : "#ccc"};
    }

    &:focus {
      outline: 3px solid ${theme.palette.mode === "dark" ? "#4CAF50" : "#2196F3"};
      border-color: ${theme.palette.mode === "dark" ? "#4CAF50" : "#2196F3"};
    }

    &:disabled {
      opacity: 0.3;
    }
  }
`
);

export default IngredientList;
